import { Badge, Grid, Label } from "@aws-amplify/ui-react";
import { CCard } from "@coreui/react";
import LocalizedStrings from "react-localization";
import moment from "moment";

const UploadEquipmentLog = ({ item }) => {
  return (
    <CCard
      className="p-3"
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      <Grid gap="5px">
        <span className="fs-5">{strings.equipment}</span>
        <Grid
          gap="25px"
          templateColumns={{ base: "1fr", xl: "1fr 1fr 1fr 1fr" }}
        >
          <Grid>
            <Label>{strings.createdAt}</Label>
            <span className="text-muted">
              {moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss")}
            </span>
          </Grid>
          <Grid>
            <Label>{strings.status.label}</Label>
            {item.loading ? (
              <Badge width="fit-content" variation="warning">
                {strings.status.options.loading}
              </Badge>
            ) : item.error ? (
              <Badge width="fit-content" variation="error">
                {strings.status.options.failed}
              </Badge>
            ) : (
              <Badge width="fit-content" variation="success">
                {strings.status.options.succeed}
              </Badge>
            )}
          </Grid>
          <Grid>
            <Label>{strings.succeedEquipments}</Label>
            <span className="text-muted">{item.equipmentsSucceed}</span>
          </Grid>
          <Grid>
            <Label>{strings.failedEquipments}</Label>
            <span className="text-muted">{item.equipmentsFailed}</span>
          </Grid>
        </Grid>
        {item.error && (
          <Grid>
            <Label>{strings.error}</Label>
            <span className="text-muted">{item.error}</span>
          </Grid>
        )}
      </Grid>
    </CCard>
  );
};

const strings = new LocalizedStrings({
  es: {
    createdAt: "Fecha de Carga",
    status: {
      label: "Estado",
      options: {
        loading: "En proceso",
        succeed: "Exitosa",
        failed: "Fallida",
      },
    },
    succeedEquipments: "Equipos con creación exitosa",
    failedEquipments: "Equipos con creación fallida",
    error: "Error/es",
  },
});

export default UploadEquipmentLog;
